import { useContext } from "use-context-selector";
import { FullPageLoadingContext } from "../context/FullPageLoadingContext";

export const useFullpageLoading = () => {
  const { handleShowFullPageLoading } = useContext(FullPageLoadingContext);
  return { handleShowFullPageLoading };
};
